module.exports = __webpack_public_path__ + "static/media/Impreza-GV-WRX.592ab451.jpg";